import { RegistryObject } from "@mcleod/core";
import { ImageName } from "@mcleod/images";

export class DemoDefinition extends RegistryObject {
    private _layoutPath: string;
    private _treePath: string[];
    private _imageName: ImageName;

    constructor(layoutPath: string, treePath: string[], imageName?: ImageName) {
        super();
        this.layoutPath = layoutPath;
        this.treePath = treePath;
        this.imageName = imageName;
    }

    get layoutPath(): string {
        return this._layoutPath;
    }

    set layoutPath(value: string) {
        this._layoutPath = value;
    }

    get treePath(): string[] {
        return this._treePath;
    }

    set treePath(value: string[]) {
        this._treePath = value;
    }

    get imageName(): ImageName {
        return this._imageName;
    }

    set imageName(value: ImageName) {
        this._imageName = value;
    }

    get runtimePath(): string {
        return this.layoutPath;
    }

    override get type(): string {
        return this.treePath.join(".");
    }
}
